/**
 * Mobile Image Zoom (in place, Mejuri-style)
 * - Pinch to zoom in and out (variable), anchored on the pinch center.
 * - Tap the image to zoom to a preset toward the point you touched; tap again to exit.
 * - Drag with one finger to pan while zoomed. Corner button toggles zoom to center.
 * - No fullscreen overlay. Gallery swipe is disabled while zoomed. Below 750px only.
 */
(function () {
  'use strict';

  var TAP_SCALE = 1.9, MAX_SCALE = 3.2, SNAP_OUT = 1.08;
  var EASE = 'transform 0.28s cubic-bezier(0.22, 1, 0.36, 1)';
  var MOVE_TOL = 8;

  function isMobile() { return window.innerWidth < 750; }
  function d2(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function midOf(a, b) { return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

  function expandIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M14 3h7v7"/><path d="M21 3l-8 8"/><path d="M10 21H3v-7"/><path d="M3 21l8-8"/></svg>';
  }
  function collapseIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M20 10h-6V4"/><path d="M21 3l-7 7"/><path d="M4 14h6v6"/><path d="M3 21l7-7"/></svg>';
  }

  function getSwiper(w) { var el = w.querySelector('.swiper'); return (el && el.swiper) || null; }
  function activeImg(w) {
    var s = w.querySelector('.swiper-slide-active') || w.querySelector('.swiper-slide:not(.swiper-slide-duplicate)');
    return s ? s.querySelector('img') : null;
  }

  function init() {
    if (!isMobile()) return;
    var wrap = document.querySelector('.product__mobile-hero-media');
    if (!wrap || wrap.dataset.mzoomInit) return;
    wrap.dataset.mzoomInit = '1';

    var btn = document.createElement('button');
    btn.className = 'mzoom-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Zoom image');
    btn.innerHTML = expandIcon();
    wrap.appendChild(btn);

    var st = {
      scale: 1, panX: 0, panY: 0, img: null, swiper: null,
      cx: 0, cy: 0, w: 0, h: 0,
      mode: 'none', sx: 0, sy: 0, spx: 0, spy: 0, moved: false,
      d0: 0, s0: 1, ux: 0, uy: 0
    };

    /* (re)measure the active slide (untransformed container, stable while the image scales) */
    function target() {
      var img = activeImg(wrap);
      if (!img) return false;
      st.img = img;
      st.swiper = getSwiper(wrap);
      var slide = img.closest('.swiper-slide') || img.parentElement;
      var r = slide.getBoundingClientRect();
      st.cx = r.left + r.width / 2;
      st.cy = r.top + r.height / 2;
      st.w = r.width; st.h = r.height;
      return true;
    }

    function apply(ease) {
      if (!st.img) return;
      var mx = st.w * (st.scale - 1) / 2, my = st.h * (st.scale - 1) / 2;
      st.panX = Math.max(-mx, Math.min(mx, st.panX));
      st.panY = Math.max(-my, Math.min(my, st.panY));
      st.img.style.transition = ease ? EASE : 'none';
      st.img.style.transform = 'translate3d(' + st.panX.toFixed(1) + 'px,' + st.panY.toFixed(1) + 'px,0) scale(' + st.scale.toFixed(3) + ')';
    }

    function enterZoom() {
      st.img.style.transformOrigin = 'center center';
      st.img.style.willChange = 'transform';
      wrap.classList.add('mzoom-on');
      var s = st.img.closest('.swiper-slide'); if (s) s.classList.add('mzoom-slide');
      if (st.swiper) st.swiper.allowTouchMove = false;
      btn.innerHTML = collapseIcon(); btn.setAttribute('aria-label', 'Zoom out');
    }
    function exitZoom() {
      if (st.img) {
        st.img.style.transition = EASE;
        st.img.style.transform = '';
        st.img.style.willChange = '';
        var s = st.img.closest('.swiper-slide'); if (s) s.classList.remove('mzoom-slide');
      }
      st.scale = 1; st.panX = 0; st.panY = 0;
      wrap.classList.remove('mzoom-on');
      if (st.swiper) st.swiper.allowTouchMove = true;
      btn.innerHTML = expandIcon(); btn.setAttribute('aria-label', 'Zoom image');
      st.img = null; st.mode = 'none';
    }
    function zoomToPoint(cx, cy, scale) {
      if (!target()) return;
      st.scale = Math.min(MAX_SCALE, scale);
      var dx = (cx == null) ? 0 : (cx - st.cx), dy = (cy == null) ? 0 : (cy - st.cy);
      st.panX = -dx * (st.scale - 1); st.panY = -dy * (st.scale - 1);
      enterZoom(); apply(true);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (st.scale > 1) exitZoom(); else zoomToPoint(null, null, TAP_SCALE);
    });

    wrap.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        if (!target()) return;
        st.mode = 'pinch';
        st.d0 = d2(e.touches[0], e.touches[1]);
        st.s0 = st.scale;
        var m = midOf(e.touches[0], e.touches[1]);
        st.ux = (m.x - st.cx - st.panX) / st.scale;   /* content point under the pinch center */
        st.uy = (m.y - st.cy - st.panY) / st.scale;
        enterZoom();
      } else if (e.touches.length === 1) {
        st.sx = e.touches[0].clientX; st.sy = e.touches[0].clientY;
        st.spx = st.panX; st.spy = st.panY; st.moved = false;
        st.mode = (st.scale > 1) ? 'pan' : 'tap';
      }
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      if (st.mode === 'pinch' && e.touches.length >= 2) {
        e.preventDefault();
        var d = d2(e.touches[0], e.touches[1]);
        var ratio = st.d0 > 0 ? d / st.d0 : 1;
        st.scale = Math.max(1, Math.min(MAX_SCALE, st.s0 * ratio));
        var m = midOf(e.touches[0], e.touches[1]);
        st.panX = m.x - st.cx - st.ux * st.scale;      /* keep the pinch point anchored */
        st.panY = m.y - st.cy - st.uy * st.scale;
        apply(false);
      } else if (st.mode === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        var dx = e.touches[0].clientX - st.sx, dy = e.touches[0].clientY - st.sy;
        if (Math.abs(dx) > MOVE_TOL || Math.abs(dy) > MOVE_TOL) st.moved = true;
        st.panX = st.spx + dx; st.panY = st.spy + dy;
        apply(false);
      } else if (st.mode === 'tap' && e.touches.length === 1) {
        var mx = e.touches[0].clientX - st.sx, my = e.touches[0].clientY - st.sy;
        if (Math.abs(mx) > MOVE_TOL || Math.abs(my) > MOVE_TOL) st.moved = true; /* a swipe: let Swiper handle it */
      }
    }, { passive: false });

    wrap.addEventListener('touchend', function (e) {
      /* one finger lifted mid-pinch: carry on as a pan */
      if (st.mode === 'pinch' && e.touches.length === 1) {
        st.mode = 'pan';
        st.sx = e.touches[0].clientX; st.sy = e.touches[0].clientY;
        st.spx = st.panX; st.spy = st.panY; st.moved = true;
        return;
      }
      if (e.touches.length > 0) return;   /* fingers still down */

      if (st.mode === 'pinch') {
        if (st.scale <= SNAP_OUT) exitZoom(); else apply(true);
      } else if (st.mode === 'pan') {
        if (!st.moved) exitZoom();         /* tap while zoomed = exit */
        else apply(true);
      } else if (st.mode === 'tap') {
        if (!st.moved && !e.target.closest('.mzoom-btn')) zoomToPoint(st.sx, st.sy, TAP_SCALE);
      }
      st.mode = 'none';
    });

    var sw = getSwiper(wrap);
    if (sw && typeof sw.on === 'function') sw.on('slideChange', function () { if (st.scale > 1) exitZoom(); });
    window.addEventListener('resize', function () { if (st.scale > 1 && !isMobile()) exitZoom(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
